import parseIntFromStr from "./parseIntFromStr";
import { onlyNumbers } from '../constants/validityPatterns';

export default function restrictIncorrectInput(value) {
    const changedValue = parseIntFromStr(value.replace(onlyNumbers, ""));
    return Number.isNaN(changedValue) ? 0 : changedValue;
}